// extracted by mini-css-extract-plugin
module.exports = {"styledSubmitButton":"whEPXxTN"};